import { useQuery } from "@tanstack/react-query";
import { fetchCVE } from "@/utils/dashboardFetch";

export const useCVEQuery = () => {
    return useQuery({
        queryKey: ['cve-dashboard'],
        queryFn: fetchCVE,
        staleTime: 1000 * 60 * 15, // 15 minutes
    });
};
